import React from "react";
import { Divider, Flex, LegacyCard, Space, Typography } from "@payping/web-components";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { Customer } from "@/pages/Shop/Invoice/forms/type";
import { CuToman } from "@payping/icons";
import { formatLocalizedNumber } from "@payping/utilities-shared/number";

interface Props {
  invoiceName?: string;
  invoiceNumber?: string;
  sentDate?: string;
  dueDate?: string;
  countProduct?: number;
  sumTotalAmount: number;
  coupon?: number;
  transport?: number;
  totalAmount?: number;
  selectedCustomer: Customer[];
}
const DataCard: React.FC<Props> = (props: Props) => {
  const {
    invoiceName,
    invoiceNumber,
    sentDate,
    dueDate,
    countProduct,
    sumTotalAmount,
    coupon,
    transport,
    totalAmount,
    selectedCustomer,
  } = props;
  const { t } = useAppTranslation();
  return (
    <LegacyCard.Ant>
      <Space orientation={"vertical"} size={"middle"} className={"tw:w-full"}>
        <div className={"tw:flex tw:justify-between"}>
          <Typography.Text strong>{t("invoice.name")}</Typography.Text>
          <Typography.Text type={"secondary"}>{invoiceName}</Typography.Text>
        </div>
        <Space>
          <Typography.Text strong>{t("shop.createInvoice.anchor.invoiceNumber")}</Typography.Text>
          <Typography.Text>{invoiceNumber}</Typography.Text>
        </Space>
        <div className={"tw:flex tw:justify-between"}>
          <Space>
            <Typography.Text>{t("shop.createInvoice.anchor.sentDate")}</Typography.Text>
            <Typography.Text>{sentDate}</Typography.Text>
          </Space>
          <Space>
            <Typography.Text type={"secondary"}>{t("shop.createInvoice.anchor.dueDate")}</Typography.Text>
            <Typography.Text type={"secondary"}>{dueDate}</Typography.Text>
          </Space>
        </div>
        <Divider className={"tw:mb-0!"} />
        <div className={"tw:flex tw:justify-between"}>
          <Typography.Text>{t("shop.createInvoice.anchor.numberOfProducts")}</Typography.Text>
          <Typography.Text>{`${countProduct} ${t("shop.createInvoice.anchor.product")}`}</Typography.Text>
        </div>
        <div className={"tw:flex tw:justify-between"}>
          <Typography.Text>{t("shop.createInvoice.anchor.sumOfTotalAmount")}</Typography.Text>
          <Flex align="center">
            <Typography.Text>{`${formatLocalizedNumber({ value: sumTotalAmount })}`}</Typography.Text>
            <CuToman width={24} height={24} />
          </Flex>
        </div>
        <div className={"tw:flex tw:justify-between"}>
          <Typography.Text>{t("shop.createInvoice.anchor.coupon")}</Typography.Text>
          <Flex align="center">
            <Typography.Text>{`${formatLocalizedNumber({ value: coupon ?? 0, options: { maximumFractionDigits: 2 } })}`}</Typography.Text>
            <CuToman width={24} height={24} />
          </Flex>
        </div>
        <div className={"tw:flex tw:justify-between"}>
          <Typography.Text>{t("shop.createInvoice.anchor.transport")}</Typography.Text>
          <Flex align="center">
            <Typography.Text>{`${formatLocalizedNumber({ value: transport ?? 0, options: { maximumFractionDigits: 2 } })}`}</Typography.Text>
            <CuToman width={24} height={24} />
          </Flex>
        </div>
        <div className={"tw:flex tw:justify-between"}>
          <Typography.Text>{t("shop.createInvoice.anchor.totalAmount")}</Typography.Text>
          <Flex align="center">
            <Typography.Text>{`${formatLocalizedNumber({ value: totalAmount ?? 0, options: { maximumFractionDigits: 2 } })}`}</Typography.Text>
            <CuToman width={24} height={24} />
          </Flex>
        </div>
        <Divider className={"tw:mb-0! tw:mt-0!"} />
        <div className={"tw:flex tw:justify-between"}>
          <Typography.Text>{t("shop.createInvoice.anchor.customers")}</Typography.Text>
          <Typography.Text>{`${selectedCustomer?.length || 0} ${t(
            "shop.createInvoice.anchor.person",
          )}`}</Typography.Text>
        </div>
      </Space>
    </LegacyCard.Ant>
  );
};

export default DataCard;
